import { render, staticRenderFns } from "./EditThankYouSettings.vue?vue&type=template&id=c3d0d844&scoped=true&"
import script from "./EditThankYouSettings.vue?vue&type=script&lang=js&"
export * from "./EditThankYouSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditThankYouSettings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditThankYouSettings.vue?vue&type=style&index=1&id=c3d0d844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d0d844",
  null
  
)

export default component.exports